import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './productsSlice';
import productDetailReducer from './productDetailSlice';
import blogReducer from './blogSlice';
import blogdetailsReducer from './blogdetailsSlice';
import aboutReducer from './aboutSlice';
import profileReducer from './Profileslice';
import addressReducer from './Addressslice';
import ordersReducer from './Ordersslice';

import walletReducer from './Walletslice';
import refundReducer from './Refundslice';
import recipesReducer from './recipesSlice';

export const store = configureStore({
  reducer: {
    products: productsReducer,
    productDetail: productDetailReducer,
    blogs: blogReducer,
    blogdetails: blogdetailsReducer,
    about: aboutReducer,
    profile: profileReducer,
    addresses: addressReducer,
    orders: ordersReducer,

    wallet: walletReducer,
    refund: refundReducer,
    recipes: recipesReducer,
  },
});